import { render, staticRenderFns } from "./classMenu.vue?vue&type=template&id=5a78ae82&scoped=true&"
import script from "./classMenu.vue?vue&type=script&lang=js&"
export * from "./classMenu.vue?vue&type=script&lang=js&"
import style0 from "./classMenu.vue?vue&type=style&index=0&id=5a78ae82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78ae82",
  null
  
)

export default component.exports